export default "__VITE_ASSET__BaB8iafC__"